import type { Collection } from 'state/utils/types';

import type { SecondaryPriceType, SecondaryQuotationType } from '../../productSearch';

export type Quote = Readonly<{
  correlationId: string;
  accruedCoupon: number;
  cashAmount: number;
  quotationType: SecondaryQuotationType;
  deductedFee: string;
  price: number;
  priceType: SecondaryPriceType;
  alphaLogin: string;
  settlementPrice: number;
  upfrontFee: number;
  timeToTradeInSeconds: number;
  tradeAuthorizationStart: Date | null | undefined;
  tradeDate: string;
  eventDate: string;
  settlementDate: string;
}>;

export type QuotesMap = Collection<Quote>;

export const initialQuotesMap: QuotesMap = {};
